import { ExitFullScreenIcon } from '@radix-ui/react-icons';
import styles from '../figure.module.css';

import { notoSerif } from '@/app/ui/fonts';

import { AspectRatio, Box } from '@radix-ui/themes';
import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { createPortal } from 'react-dom';

interface Props {
  src: string;
  alt: string;
  lightboxWidths: { initial: string; sm: string; md: string; lg: string };
  lightboxHeights: { initial: string; sm: string; md: string; lg: string };
  lightboxPortal: HTMLElement | null | undefined;
  open: boolean;
  setOpen: (value: boolean) => void;
  width: number;
  height: number;
}

const FigureStatementBelow = ({
  src,
  alt,
  lightboxWidths,
  lightboxHeights,
  lightboxPortal,
  open,
  width,
  height,
  setOpen
}: Props) => {
  // const aspect = Math.round(width / height);
  const aspect = width / height;
  return (
    <>
      <Box
        width={`${width}px`}
        height={`${height}px`}
        position='relative'
        className={styles.ImageWrapper}
      >
        <Image
          src={src}
          alt={alt}
          fill
          sizes={'(max-width: 768px) 100vw, 300px'}
          onClick={() => setOpen(true)}
          style={{ borderRadius: '6px' }}
        />
      </Box>
      {lightboxPortal &&
        createPortal(
          <AnimatePresence>
            {open && (
              <AspectRatio ratio={aspect}>
                <motion.div
                  className={styles.LightboxBackdrop}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setOpen(false)}
                >
                  <Box
                    className={styles.LightboxWrapper}
                    width={{
                      initial: lightboxWidths.initial,
                      sm: lightboxWidths.sm,
                      md: lightboxWidths.md,
                      lg: lightboxWidths.lg
                    }}
                    height={{
                      initial: lightboxHeights.initial,
                      sm: lightboxHeights.sm,
                      md: lightboxHeights.md,
                      lg: lightboxHeights.lg
                    }}
                  >
                    <motion.div
                      className={styles.LightboxContent}
                      initial={{ scale: 0.5, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.5, opacity: 0 }}
                      transition={{ duration: 0.5 }}
                      onClick={e => e.stopPropagation()}
                    >
                      <Box
                        position='relative'
                        width={{
                          initial: lightboxWidths.initial,
                          sm: lightboxWidths.sm,
                          md: lightboxWidths.md,
                          lg: lightboxWidths.lg
                        }}
                        height={{
                          initial: lightboxHeights.initial,
                          sm: lightboxHeights.sm,
                          md: lightboxHeights.md,
                          lg: lightboxHeights.lg
                        }}
                        className={`${notoSerif.className} ${styles.ImageWrapper}`}
                      >
                        <Image
                          src={src}
                          alt={alt}
                          fill
                          sizes='100vw'
                          // className={styles.FullImage}
                        />
                      </Box>
                    </motion.div>
                    <div
                      id='close-image-button'
                      className={styles.FabButton}
                      onClick={e => {
                        e.stopPropagation();
                        setOpen(false);
                      }}
                    >
                      <ExitFullScreenIcon
                        width='1rem'
                        height='1rem'
                      />
                    </div>
                  </Box>
                </motion.div>
              </AspectRatio>
            )}
          </AnimatePresence>,
          lightboxPortal
        )}
    </>
  );
};

export default FigureStatementBelow;
